export const getDeposits = (subsidiaryId, token, formData) => ({
  endpoint: 'deposits',
  method: formData ? 'POST' : 'GET',
  params: { subsidiaryId },
  headers: { 'x-authentication-token': token },
  formData
});
